'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TiktokRow = exports.TelegramRow = exports.getPublishedMessage = exports.getAssetType = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _asaCompliance = require('./../asa-compliance');

var _asaCompliance2 = _interopRequireDefault(_asaCompliance);

var _instagramIcon = require('./../instagram-icon');

var _instagramIcon2 = _interopRequireDefault(_instagramIcon);

var _formatting = require('./../../utils/formatting');

var _facebookPostType = require('./../facebook-post-type');

var _facebookPostType2 = _interopRequireDefault(_facebookPostType);

var _twitterPostType = require('./../twitter-post-type');

var _twitterPostType2 = _interopRequireDefault(_twitterPostType);

var _reachComponent = require('../reach-component');

var _reachComponent2 = _interopRequireDefault(_reachComponent);

var _youtubeModalComponent = require('../../components/youtube-modal-component');

var _youtubeModalComponent2 = _interopRequireDefault(_youtubeModalComponent);

var _sourceComponent = require('../source-component');

var _sourceComponent2 = _interopRequireDefault(_sourceComponent);

var _sharesComponent = require('../shares-component');

var _sharesComponent2 = _interopRequireDefault(_sharesComponent);

var _impressionsComponent = require('../impressions-component');

var _impressionsComponent2 = _interopRequireDefault(_impressionsComponent);

var _notAvailableComponent = require('../not-available-component');

var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);

var _privateDataComponent = require('../private-data-component');

var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);

var _imageComponent = require('./components/image-component');

var _imageComponent2 = _interopRequireDefault(_imageComponent);

var _manualDataComponent = require('./components/manual-data-component');

var _manualDataComponent2 = _interopRequireDefault(_manualDataComponent);

var _storyComponents = require('./components/story-components');

var _rowComponents = require('./components/row-components');

var _dyzioIcons = require('../../components/dyzio-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CAPTION_LENGTH = 50;

var dyzioGreen = {
  color: '#20c49e'
};

var fromNow = function fromNow(date) {
  return (0, _moment2.default)(date).fromNow();
};
var smallFont = {
  fontSize: '60%',
  color: 'grey'
};

var ellipsisWrapper = {
  width: '100%'
};

var df = function df(post) {
  return (0, _moment2.default)(post.trackedAsset && post.trackedAsset.publishedDate ? post.trackedAsset.publishedDate : post.publishedDate).format('YYYY-MM-DD');
};

var getAssetType = exports.getAssetType = function getAssetType(post) {
  if (post.isIGTV) return 'IGTV';
  if (post.isReel) return 'REEL';
  if (post.isVideo) return 'video';
  if (post.isCarousel || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'CAROUSEL') return 'carousel';
  if (post.type === 'stories' || post.isStory || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'STORY') return 'story';

  return 'image';
};

var getPublishedMessage = exports.getPublishedMessage = function getPublishedMessage(post) {
  var platform = post.trackedAsset ? post.trackedAsset.platform : 'Instagram';
  var assetType = getAssetType(post);
  var date = post.trackedAsset ? post.trackedAsset.publishedDate : post.publishedDate;

  if (post.tweetId) {
    console.log(post);
    var tweetMedia = _lodash2.default.get(post, 'entities.media') || [];
    var mainTweetMedia = _lodash2.default.head(tweetMedia);
    var mediaUrl = _lodash2.default.get(mainTweetMedia, 'expanded_url');

    console.log(mediaUrl);

    assetType = 'post';

    if (_lodash2.default.includes(mediaUrl, 'video')) {
      assetType = 'video';
    }
    if (_lodash2.default.includes(mediaUrl, 'photo')) {
      assetType = 'photo';
    }
  }

  return '\n   ' + _lodash2.default.capitalize(platform) + ' ' + assetType + ' posted at ' + (0, _moment2.default)(date).format('LT') + ' on ' + df(post);
};

var TelegramRow = exports.TelegramRow = function TelegramRow(_ref) {
  var post = _ref.post,
      deleteCallback = _ref.deleteCallback;
  var initialData = post.initialData,
      telegramData = post.telegramData;

  var latestTelegramData = _lodash2.default.last(_lodash2.default.sortBy(telegramData, 'createdDate')) || initialData;
  var publishedDate = (0, _moment2.default)(post.publishedDate).format('YYYY-MM-DD');
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', color: 'blue' }),
          _react2.default.createElement(
            'p',
            { style: smallFont },
            publishedDate
          )
        ),
        content: 'TELEGRAM posted at ' + (0, _moment2.default)(post.publishedDate).format('LT') + ' on ' + publishedDate
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_imageComponent2.default, { post: post })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(
        _semanticUiReact.Header,
        { as: 'h5' },
        _react2.default.createElement(
          _semanticUiReact.Header.Content,
          { style: ellipsisWrapper },
          post.discussionName,
          _react2.default.createElement(
            _semanticUiReact.Header.Subheader,
            null,
            _react2.default.createElement(
              'span',
              { style: ellipsisWrapper },
              initialData.text || '(uncaptioned)'
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(
        'div',
        { style: dyzioGreen },
        _react2.default.createElement(_semanticUiReact.Popup, {
          content: 'view post on Telegram',
          trigger: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              {
                target: '_blank',
                rel: 'noopener noreferrer',
                href: post.assetURL,
                style: dyzioGreen
              },
              _react2.default.createElement(_semanticUiReact.Icon, {
                name: 'external'
              }),
              _react2.default.createElement(
                'div',
                { style: smallFont },
                'view...'
              )
            )
          )
        })
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        hoverable: true,
        trigger: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: dyzioGreen },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock alternate' }),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed' })
          ),
          _react2.default.createElement(
            'div',
            { style: smallFont },
            fromNow(latestTelegramData.createdDate)
          )
        ),
        content: 'Public data collected from the TELEGRAM API ' + fromNow(latestTelegramData.createdDate)
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'video views', platform: 'Telegram', assetType: 'post' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.sciFormatted)(latestTelegramData.views)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'impression', platform: 'Telegram', assetType: 'post' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'likes', platform: 'Telegram', assetType: 'post' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      latestTelegramData.replies ? (0, _formatting.sciFormatted)(latestTelegramData.replies.replies) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.sciFormatted)(latestTelegramData.forwards)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_notAvailableComponent2.default, { metricName: '#ad', platform: 'Telegram', assetType: 'post' })
    ),
    deleteCallback && _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'grey' }),
        content: 'Cannot delete a telegram'
      })
    )
  );
};

var TiktokRow = exports.TiktokRow = function TiktokRow(_ref2) {
  var post = _ref2.post,
      deleteCallback = _ref2.deleteCallback,
      inGIMode = _ref2.inGIMode;
  var initialData = post.initialData,
      tiktokData = post.tiktokData;

  var user = _lodash2.default.get(initialData, 'authorMeta.name.uniqueId') ? _lodash2.default.get(initialData, 'authorMeta.name') : _lodash2.default.get(initialData, 'authorMeta') || _lodash2.default.get(initialData, 'author');
  var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
  var publishedDate = (0, _moment2.default)(post.publishedDate).format('YYYY-MM-DD');
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_dyzioIcons.TiktokIcon, null),
          _react2.default.createElement(
            'p',
            { style: smallFont },
            publishedDate
          )
        ),
        content: 'TIKTOK posted at ' + (0, _moment2.default)(post.publishedDate).format('LT') + ' on ' + publishedDate
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_imageComponent2.default, { post: post })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(
        _semanticUiReact.Header,
        { as: 'h5' },
        _react2.default.createElement(
          _semanticUiReact.Header.Content,
          { style: ellipsisWrapper },
          user.nickName || user.uniqueId,
          ' (',
          user.name || user.nickname,
          ')',
          _react2.default.createElement(
            _semanticUiReact.Header.Subheader,
            null,
            _react2.default.createElement(
              'span',
              { style: ellipsisWrapper },
              initialData.text || initialData.desc || '(uncaptioned)'
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(
        'div',
        { style: dyzioGreen },
        _react2.default.createElement(_semanticUiReact.Popup, {
          content: 'view post on Tiktok',
          trigger: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              {
                target: '_blank',
                rel: 'noopener noreferrer',
                href: post.assetURL,
                style: dyzioGreen
              },
              _react2.default.createElement(_semanticUiReact.Icon, {
                name: 'external'
              }),
              _react2.default.createElement(
                'div',
                { style: smallFont },
                'view...'
              )
            )
          )
        })
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        hoverable: true,
        trigger: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: dyzioGreen },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock alternate' }),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed' })
          ),
          _react2.default.createElement(
            'div',
            { style: smallFont },
            fromNow(latestTiktokData.createdDate)
          )
        ),
        content: 'Public data collected from the Tiktok API ' + fromNow(latestTiktokData.createdDate)
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      inGIMode && _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'impression', platform: 'Tiktok', assetType: 'post' }),
      !inGIMode && (0, _formatting.sciFormatted)(latestTiktokData.playCount)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.sciFormatted)(latestTiktokData.playCount * 0.92)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      !inGIMode && (0, _formatting.sciFormatted)(latestTiktokData.playCount * 1.08),
      inGIMode && (0, _formatting.sciFormatted)(latestTiktokData.playCount)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.sciFormatted)(latestTiktokData.diggCount)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.sciFormatted)(latestTiktokData.commentCount)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.sciFormatted)(latestTiktokData.shareCount)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_notAvailableComponent2.default, { metricName: '#ad', platform: 'Tiktok', assetType: 'post' })
    ),
    deleteCallback && _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'grey' }),
        content: 'Cannot delete a tiktok'
      })
    )
  );
};

var StoryRow = function StoryRow(_ref3) {
  var story = _ref3.story,
      deleteCallback = _ref3.deleteCallback;
  var storyData = story.attributes.storyData;
  var data = story.relationships.supportingData.data;

  var latestSupportingData = _lodash2.default.last(data) || {};
  var isVideo = _lodash2.default.get(story, 'attributes.assetType') === 'VIDEO';
  var latestData = _lodash2.default.last(storyData);
  var views = _lodash2.default.get(latestSupportingData, 'attributes.views') || _lodash2.default.get(latestData, 'views') || _lodash2.default.get(latestData, 'impressions', 0);
  var atts = story.attributes;
  var truncatedCaption = _lodash2.default.truncate(atts.caption, { length: CAPTION_LENGTH });
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _semanticUiReact.Icon.Group,
              null,
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
              _react2.default.createElement(_semanticUiReact.Icon, { corner: true, name: 'circle outline', color: 'pink' })
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'video play' : 'image', color: 'pink' })
          ),
          atts.status === 'LIVE' ? _react2.default.createElement(
            'p',
            { style: { fontSize: '80%', color: '#20c49e' } },
            atts.status
          ) : _react2.default.createElement(
            'p',
            { style: smallFont },
            df(story)
          )
        ),
        content: getPublishedMessage(story)
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_storyComponents.StoryImageModalComponent, { story: story })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(
        _semanticUiReact.Header,
        { as: 'h5' },
        _react2.default.createElement(
          _semanticUiReact.Header.Content,
          { style: ellipsisWrapper },
          atts.username,
          _react2.default.createElement(
            _semanticUiReact.Header.Subheader,
            null,
            _react2.default.createElement(
              'span',
              { style: ellipsisWrapper },
              truncatedCaption || '(uncaptioned)'
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(
        'div',
        { style: dyzioGreen },
        _react2.default.createElement(_storyComponents.StoryIconModalComponent, { story: story })
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        hoverable: true,
        trigger: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: dyzioGreen },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock alternate' }),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed' })
          ),
          _react2.default.createElement(
            'div',
            { style: smallFont },
            fromNow(latestData.createdDate)
          )
        ),
        content: 'Authorised data collected from the Instagram API ' + fromNow(latestData.createdDate)
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      isVideo ? (0, _formatting.sciFormatted)(views) : _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'views', platform: 'Instagram', assetType: 'Story' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.sciFormatted)(_lodash2.default.get(latestSupportingData, 'attributes.reach') || latestData.reach)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.sciFormatted)(_lodash2.default.get(latestSupportingData, 'attributes.impressions') || latestData.impressions)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'likes', platform: 'Instagram', assetType: 'Story' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'comments', platform: 'Instagram', assetType: 'Story' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'shares', platform: 'Instagram', assetType: 'Story' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_asaCompliance2.default, { text: atts.caption })
    ),
    deleteCallback && _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'grey' }),
        content: 'Cannot delete a story'
      })
    )
  );
};

var BasicReportRow = function BasicReportRow(props) {
  var post = props.post,
      viewMode = props.viewMode,
      deleteCallback = props.deleteCallback;

  if (post && (post.platform === 'VK' || post.platform === 'BLOG' || post.platform === 'SNAPCHAT')) {
    return _react2.default.createElement(_manualDataComponent2.default, { asset: post, deleteCallback: deleteCallback });
  }
  if (post && post.platform === 'TIKTOK') {
    return _react2.default.createElement(TiktokRow, { post: post, deleteCallback: deleteCallback });
  }
  if (post && post.platform === 'TELEGRAM' && post.initialData) {
    return _react2.default.createElement(TelegramRow, { post: post, deleteCallback: deleteCallback });
  }
  if (post && post.type === 'stories') {
    return _react2.default.createElement(StoryRow, { story: post, deleteCallback: deleteCallback });
  }
  switch (post.trackedAsset.platform) {
    case 'TWITTER':
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', color: 'blue' }),
              _react2.default.createElement(_twitterPostType2.default, { asset: post }),
              _react2.default.createElement(
                'p',
                { style: smallFont },
                df(post)
              )
            ),
            content: getPublishedMessage(post)
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_imageComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { textAlign: 'left' },
          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            'div',
            { style: dyzioGreen },
            _react2.default.createElement(_semanticUiReact.Popup, {
              content: 'view tweet on twitter',
              trigger: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'a',
                  {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    href: post.trackedAsset.assetURL,
                    style: dyzioGreen
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, {
                    name: 'external'
                  }),
                  _react2.default.createElement(
                    'div',
                    { style: smallFont },
                    'view...'
                  )
                )
              )
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_sourceComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'views', platform: post.trackedAsset.platform, assetType: 'tweet' })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_reachComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_impressionsComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.sciFormatted)(post.latestStatistic.favoriteCount)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.sciFormatted)(post.latestStatistic.commentCount)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.sciFormatted)(post.latestStatistic.retweetCount)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_asaCompliance2.default, { text: post.text })
        ),
        deleteCallback && _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
        )
      );
    case 'FACEBOOK':
      var latestInsights = post.latestInsights;

      var views = latestInsights ? latestInsights.totalVideoViews : post.latestStatistic.viewCount;
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue' }),
              _react2.default.createElement(_facebookPostType2.default, { asset: post }),
              _react2.default.createElement(
                'p',
                { style: smallFont },
                df(post)
              )
            ),
            content: getPublishedMessage(post)
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_imageComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { textAlign: 'left' },
          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            'div',
            { style: dyzioGreen },
            _react2.default.createElement(_semanticUiReact.Popup, {
              content: 'view post on facebook',
              trigger: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'a',
                  {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    href: post.trackedAsset.assetURL,
                    style: dyzioGreen
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, {
                    name: 'external'
                  }),
                  _react2.default.createElement(
                    'div',
                    { style: smallFont },
                    'view...'
                  )
                )
              )
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_sourceComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          post.postType === 'post' || post.postType === 'photo' ? _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'views', platform: post.trackedAsset.platform, assetType: post.postType }) : _react2.default.createElement(
            'span',
            null,
            (0, _formatting.sciFormatted)(views)
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_reachComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_impressionsComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.sciFormatted)(post.latestStatistic.likeCount)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.sciFormatted)(post.latestStatistic.commentCount)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_sharesComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_asaCompliance2.default, { text: post.text })
        ),
        deleteCallback && _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
        )
      );
    case 'YOUTUBE':
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                { style: smallFont },
                _react2.default.createElement(
                  'strong',
                  { style: { color: 'red' } },
                  'YOUTUBE'
                )
              ),
              _react2.default.createElement(
                'p',
                { style: smallFont },
                df(post)
              )
            ),
            content: getPublishedMessage(post)
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_imageComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { textAlign: 'left' },
          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            'div',
            { style: dyzioGreen },
            true ? _react2.default.createElement(
              'p',
              null,
              '-'
            ) : _react2.default.createElement(_youtubeModalComponent2.default, { post: post })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_sourceComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.sciFormatted)(_lodash2.default.last(post.statistics).viewCount)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_reachComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_impressionsComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.sciFormatted)(_lodash2.default.last(post.statistics).likeCount)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.sciFormatted)(_lodash2.default.last(post.statistics).commentCount)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'shares', platform: post.trackedAsset.platform, assetType: post.postType })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_asaCompliance2.default, { text: post.description })
        ),
        deleteCallback && _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
        )
      );
    case 'INSTAGRAM':
      var isIGTV = post.isIGTV;
      var isReel = post.isReel;
      var isStory = _lodash2.default.get(post, 'trackedAsset.assetType') === 'STORY';

      var supportingData = post.trackedAsset.supportingData;

      var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
      var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
        return o.createdDate;
      }));
      var latestSupportingData = ordered[0];

      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: post.trackedAsset.assetType === 'STORY' ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                { style: { margin: 0 } },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', color: 'pink' })
              ),
              _react2.default.createElement(
                'p',
                { style: smallFont },
                df(post)
              )
            ) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_instagramIcon2.default, { post: post }),
              _react2.default.createElement(
                'p',
                { style: smallFont },
                df(post)
              )
            ),
            content: getPublishedMessage(post)
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_imageComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { textAlign: 'left' },
          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          isStory && _react2.default.createElement(_storyComponents.StoryIconModalComponent, { story: post, inManualStoryMode: true }),
          !isStory && _react2.default.createElement(
            'div',
            { style: dyzioGreen },
            _react2.default.createElement(_semanticUiReact.Popup, {
              content: 'view post on instagram',
              trigger: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'a',
                  {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    href: post.trackedAsset.assetURL,
                    style: dyzioGreen
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, {
                    name: 'external'
                  }),
                  _react2.default.createElement(
                    'div',
                    { style: smallFont },
                    'view...'
                  )
                )
              )
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_sourceComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _lodash2.default.has(latestSupportingData, 'views') ? (0, _formatting.sciFormatted)(_lodash2.default.get(latestSupportingData, 'views')) : isReel ? (0, _formatting.sciFormatted)(post.latestStatistic.playCount) : post.isVideo ? (0, _formatting.sciFormatted)(post.latestStatistic.viewCount) : _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'views', platform: post.trackedAsset.platform, assetType: 'image' })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_reachComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_impressionsComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          post.latestStatistic ? (0, _formatting.sciFormatted)(post.latestStatistic.likeCount) : _react2.default.createElement(_privateDataComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          post.latestStatistic ? (0, _formatting.sciFormatted)(post.latestStatistic.commentCount) : _react2.default.createElement(_privateDataComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_sharesComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_rowComponents.AdWrapper, { post: post })
        ),
        deleteCallback && _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
        )
      );
    case 'SNAPCHAT':
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'snapchat', color: 'yellow' }),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'photo', color: 'yellow' })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_imageComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { textAlign: 'left' },
          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'external', color: 'green' })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_sourceComponent2.default, { post: post })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.sciFormatted)(post.latestStatistic.openCount)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'reach', platform: post.trackedAsset.platform, assetType: 'post' })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'impressions', platform: post.trackedAsset.platform, assetType: 'post' })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'likes', platform: post.trackedAsset.platform, assetType: 'post' })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'comments', platform: post.trackedAsset.platform, assetType: 'post' })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'shares', platform: post.trackedAsset.platform, assetType: 'post' })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_notAvailableComponent2.default, { metricName: '#ad', platform: post.trackedAsset.platform, assetType: 'post' })
        ),
        deleteCallback && _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
        )
      );
    default:
      return _react2.default.createElement(_semanticUiReact.Table.Row, null);
  }
};

BasicReportRow.propTypes = {
  post: _propTypes2.default.object.isRequired,
  viewMode: _propTypes2.default.string.isRequired,
  deleteCallback: _propTypes2.default.func
};

BasicReportRow.defaultProps = {
  viewMode: 'external',
  deleteCallback: _lodash2.default.noop
};

exports.default = BasicReportRow;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-row/index.js
 ** module id = 2588
 ** module chunks = 0
 **/